import { ApplicationId } from "@1games-ru/region-shared/dist/enums/tablet/applicationd-id";
import {
  svgTabletMarketplace,
  svgTabletMyBusiness,
  svgTabletMyFaction,
  svgTabletMyHouse,
  svgTabletMyTransport,
} from "@/shared/assets/svg";

export const applicationsInfo: Record<ApplicationId, { name: string; icon: string }> = {
  [ApplicationId.House]: {
    name: "Мой дом",
    icon: svgTabletMyHouse,
  },
  [ApplicationId.Business]: {
    name: "Мой бизнес",
    icon: svgTabletMyBusiness,
  },
  [ApplicationId.Faction]: {
    name: "Моя фракция",
    icon: svgTabletMyFaction,
  },
  [ApplicationId.TransportWarehouse]: {
    name: "Склад",
    icon: svgTabletMyTransport,
  },
  [ApplicationId.Marketplace]: {
    name: "Маркетплейс",
    icon: svgTabletMarketplace,
  },
};
